import { render, staticRenderFns } from "./section_7.vue?vue&type=template&id=22c919d1&scoped=true&"
import script from "./section_7.vue?vue&type=script&lang=js&"
export * from "./section_7.vue?vue&type=script&lang=js&"
import style0 from "./section_7.vue?vue&type=style&index=0&id=22c919d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c919d1",
  null
  
)

component.options.__file = "section_7.vue"
export default component.exports